export const iconFontAwesomeHolidaysCarrot = (
	<i className="fa-solid fa-carrot"></i>
);
